/**
 * Cross-tab consent message routing — platform-wide storage tenant + global scope.
 */
import type { CustomerConsentCrossTabMessage } from 'pi-kiosk-shared/crossTab';
import { resolveConsentStorageTenantCode } from './consentStorageTenant.js';

export function shouldHandleConsentCrossTabMessage(
  message: CustomerConsentCrossTabMessage,
  browseTenantCode: string,
  sessionTenantId: number | null,
): boolean {
  if (message.scope === 'global') {
    return true;
  }
  const storageTenant = resolveConsentStorageTenantCode(browseTenantCode);
  if (message.tenantCode === storageTenant) {
    return true;
  }
  if (message.source === 'admin') {
    if (message.tenantId !== undefined && sessionTenantId !== null) {
      return message.tenantId === sessionTenantId;
    }
    if (message.tenantCode !== undefined) {
      return message.tenantCode === browseTenantCode;
    }
    return false;
  }
  if (message.tenantCode !== undefined && message.tenantCode !== browseTenantCode) {
    return false;
  }
  return true;
}
